import { render, staticRenderFns } from "./arrears.vue?vue&type=template&id=397b92ba&scoped=true"
import script from "./arrears.vue?vue&type=script&lang=js"
export * from "./arrears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b92ba",
  null
  
)

export default component.exports